/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
// FIMO enums with no imports, so modules that read them at load time (e.g. the cost item import
// spec) work whatever order the models index evaluates in. Re-exported from `./fimo`.
export var ValidDepreciationValues;
(function (ValidDepreciationValues) {
    ValidDepreciationValues["NON_DEPRECIABLE"] = "non_depreciable";
    ValidDepreciationValues["TWELVE_YEAR_SL"] = "twelve_year_sl";
    ValidDepreciationValues["TWENTY_YEAR_SL"] = "twenty_year_sl";
    ValidDepreciationValues["THIRTY_FIVE_YEAR_SL"] = "thirty_five_year_sl";
    ValidDepreciationValues["INDIRECT"] = "indirect";
    ValidDepreciationValues["NOT_APPLICABLE"] = "not_applicable";
    ValidDepreciationValues["FIVE_YEAR_MACRS"] = "five_year_macrs";
})(ValidDepreciationValues || (ValidDepreciationValues = {}));
/** Depreciation schedules a capital cost item can choose (`not_applicable` describes no item). */
export const COST_ITEM_DEPRECIATION_SCHEDULES = Object.values(ValidDepreciationValues).filter((value) => value !== ValidDepreciationValues.NOT_APPLICABLE);
export var CostItemScope;
(function (CostItemScope) {
    CostItemScope["PROJECT"] = "project";
    CostItemScope["PV"] = "pv";
    CostItemScope["ESS"] = "ess";
})(CostItemScope || (CostItemScope = {}));
export var CostItemDirection;
(function (CostItemDirection) {
    CostItemDirection["COST"] = "cost";
    CostItemDirection["CREDIT"] = "credit";
})(CostItemDirection || (CostItemDirection = {}));
/** Unit of a cost item's schedule values and the quantity each value is multiplied by. */
export var CostItemBasis;
(function (CostItemBasis) {
    CostItemBasis["USD"] = "usd";
    CostItemBasis["USD_PER_KW_DC"] = "usd_per_kw_dc";
    CostItemBasis["USD_PER_KW_AC"] = "usd_per_kw_ac";
    CostItemBasis["USD_PER_KWH_ESS"] = "usd_per_kwh_ess";
    CostItemBasis["USD_PER_MWH_NET_GEN"] = "usd_per_mwh_net_gen";
})(CostItemBasis || (CostItemBasis = {}));
export const costItemScheduleKinds = [
    'flat_escalating',
    'annual_series',
    'monthly_series',
    'dated_payments',
];
//# sourceMappingURL=fimo-enums.js.map